var borderColor = 'grey.300';
var baseStyleContainer = {
  borderRadius: 'xs',
  borderColor: borderColor,
  boxShadow: 'base'
};
var baseStylePanel = {
  borderColor: borderColor,
  borderBottomRightRadius: 'xs',
  borderBottomLeftRadius: 'xs'
};
var baseStyleHeader = {
  borderColor: borderColor,
  borderTopLeftRadius: 'xs',
  borderTopRightRadius: 'xs',
  borderBottomRightRadius: 'xs',
  borderBottomLeftRadius: 'xs',
  alignItems: 'flex-start',
  fontWeight: 'bold',
  letterSpacing: 0,
  py: '.75rem',
  '&[data-open="true"]': {
    bg: 'grey.100'
  }
};
var baseStyleButton = {
  color: 'blue.275',
  fontSize: '1.5rem',
  width: '1.5rem',
  height: '1.5rem'
};
var baseStyle = {
  container: baseStyleContainer,
  header: baseStyleHeader,
  panel: baseStylePanel,
  button: baseStyleButton
};
export var Accordion = {
  baseStyle
};